import * as React from "react";
import { UitkSecondaryButton } from "uitk-react-button";
import {
  LocalizedText,
  LocalizedComponentClass,
  LocalizedComponentProps,
  withLocalization
} from "bernie-l10n";
import { UitkCardTextSegment } from "uitk-react-cards";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { GeoType } from "src/typings/flexFramework/FlexDefinitions";

interface SeeAllButtonProps extends LocalizedComponentProps {
  showMoreStrategy: string;
  tokens: { [index: string]: string };
  seeAllLink: string;
  seeAllType: string;
  moduleName: string;
  locationName: string;
  locationType: GeoType;
  isAffinityFiltersSeeMoreLinkExperimentEnabled: boolean;
  affinityDescription: string;
}

export const SeeAllButtonComponent = (props: SeeAllButtonProps) => {
  const {
    locationName,
    isAffinityFiltersSeeMoreLinkExperimentEnabled,
    affinityDescription
  } = props;

  if (props.showMoreStrategy !== "button") {
    return null;
  }

  let weGotLocationsMessage;
  let weGotLocationsParams;
  const ButtonTracked = FlexClickTracker(UitkSecondaryButton);

  if (
    isAffinityFiltersSeeMoreLinkExperimentEnabled &&
    affinityDescription !== null &&
    affinityDescription !== ""
  ) {
    weGotLocationsMessage = "hotels.affinity.gotMoreProperties";
    weGotLocationsParams = [affinityDescription, locationName];
  } else {
    weGotLocationsMessage = "hotels.seeAllAvailableProperties";
    weGotLocationsParams = [locationName];
  }

  return (
    <UitkCardTextSegment className="uitk-type-center">
      <div className="uitk-type-bold all-r-margin-one hotelRating uitk-type-300 all-t-padding-three">
        <LocalizedText message="hotels.lookingFor" />
      </div>
      <div className="uitk-type-300">
        <LocalizedText message={weGotLocationsMessage} data={weGotLocationsParams} />
      </div>

      <UitkCardTextSegment>
        <ButtonTracked
          text={props.l10n.formatText("hotels.viewAllProperties")}
          rfrr={props.seeAllType}
          href={props.seeAllLink}
          moduleName={props.moduleName}
          linkName={props.seeAllLink}
          rel="nofollow"
        />
      </UitkCardTextSegment>
    </UitkCardTextSegment>
  );
};

export const SeeAllButton: LocalizedComponentClass<SeeAllButtonProps> = withLocalization(
  SeeAllButtonComponent
);
